import moment from 'moment'
import config from '../configs/config'

/**
 * Defines the access token value object and helper to save the access token on the local storage.
 * @memberOf things
 */
class AccessToken
{
    /**
     * Creates a new AccessToken instance.
     * @constructor
     * @param object The generic object to initialize the object the first time.
     */
    constructor( object = null )
    {
        this.access_token  = null ;
        this.expires_in    = 0    ;
        this.id            = null ;
        this.refresh_token = null ;
        this.scope         = null ;
        this.state         = null ;
        this.timestamp     = 0    ;
        this.token_type    = null ;

        if( object )
        {
            this.set( object , false ) ;
        }
    }

    static ID = '_token' ;

    get expired()
    {
        return moment().valueOf() > this.timestamp ;
    }

    get prefix()
    {
        return this._prefix ;
    }

    set prefix( value )
    {
        const flag = this.stored ;
        if( flag )
        {
            this.dispose() ;
        }
        this._prefix = (value instanceof String || typeof(value) === 'string') ? value : '' ;
        if( flag )
        {
            this.write() ;
        }
    }

    _prefix = config.name ;

    /**
     * Indicates if the object is stored in the local storage context.
     * @returns {boolean} True if the object is stored.
     */
    get stored()
    {
        return (localStorage.getItem(this._prefix + AccessToken.ID) !== null) ;
    }

    /**
     * Clear the object.
     */
    clear( lock = false )
    {
        this.access_token  = null ;
        this.expires_in    = 0 ;
        this.id            = null ;
        this.refresh_token = null ;
        this.scope         = null ;
        this.state         = null ;
        this.timestamp     = 0 ;
        this.token_type    = null ;
        return lock === true ? this : this.write();
    }

    /**
     * Unregister the object in the local storage.
     */
    dispose()
    {
        this.clear(false);
        if( localStorage.getItem(this._prefix+AccessToken.ID) !== null )
        {
            localStorage.removeItem(this._prefix+AccessToken.ID) ;
        }
        return this ;
    }

    /**
     * Initialize the object with the current local storage.
     */
    read()
    {
        let object = JSON.parse( localStorage.getItem( this._prefix + AccessToken.ID ) ) ;
        if( object != null )
        {
            for( let prop in object )
            {
                if( object.hasOwnProperty(prop) && this.hasOwnProperty(prop) )
                {
                    this[prop] = object[prop] ;
                }
            }
        }
        return this ;
    }

    /**
     * Sets the object with a generic object and write it on the server.
     */
    set( object , lock = false )
    {
        for( let prop in object )
        {

            if( prop in this )
            {
                if( object.hasOwnProperty(prop)) {
                    this[prop] = object[prop];
                }
            }
        }

        if( (this.expires_in instanceof String) || (typeof(this.expires_in) === 'string') )
        {
            this.expires_in *= 1 ;
        }

        let date = moment() ;
        if( this.expires_in > 0 )
        {
            date.add( this.expires_in , 's' ) ;
        }

        this.timestamp = date.valueOf() ;

        return (lock === true) ? this : this.write();
    }

    /**
     * Returns the generic object representation of the object.
     * @returns {{access_token: *, expire_in: number, refresh_token: *, timestamp: *, token_type: *, scope: *, state: *}}
     */
    toObject()
    {
        return {
            access_token  : this.access_token,
            expires_in    : this.expires_in ,
            refresh_token : this.refresh_token,
            timestamp     : this.timestamp ,
            token_type    : this.token_type ,
            scope         : this.scope,
            state         : this.state
        };
    }

    /**
     * Write the object in the local storage with the specific id.
     */
    write()
    {
        localStorage.setItem( this._prefix + AccessToken.ID , JSON.stringify(this.toObject()) ) ;
        return this ;
    }
}

export { AccessToken } ;

const accessToken = new AccessToken() ;

export default accessToken ;


// WEBPACK FOOTER //
// ./src/app/things/AccessToken.js